import React, { Component } from 'react';
import { login } from '../api/UserFunctions';
import '../css/login.css';
import logo from '../img/logo/logo_color.png';
import { connect } from "react-redux";
import { changeConnexion } from "../actions/index";
import Connexion from "./Connexion";

function mapDispatchToProps(dispatch) {
    return {
      changeConnexion:connexion => dispatch(changeConnexion(connexion))
    };
}
const mapStateToProps = state => {
	return{ connexion: state.connexion}
   };

class Login extends Component {

  constructor(props){
		super(props);

		this.state = {
			email           : '',
			password        : '',
			return_code     : 0,
			style_forget    : {display: "none"},
			style_incorrect : {display: "none"},
			style_incorrect2: {display: "none"},
			style_incorrect3: {display:"none"},
			errors          : {},
			
		}
		this.onChange        = this.onChange.bind(this);
		this.onSubmit        = this.onSubmit.bind(this);
		// this.logout          = this.logout.bind(this);
		
  }

  render() {
    return (
		<div className="login-page-wrapper">
			<form onSubmit={this.onSubmit} className="form-wrapper">
				<div className="content">
					<img src={logo} alt="Au Petit Bamako"/>
					<input 
						onChange={this.onChange}  	
						type="text" 	
						name="email" 	
						placeholder="Email" 		
						value={this.state.email}
					/>
					<input 
						onChange={this.onChange} 	
						type="password" 
						name="password" 
						placeholder="Mot de passe" 	
						value={this.state.password}
					/>
				</div>
				<input className="btn-login" type="submit"  value="Se connecter"/>
				<p className="error" style={this.state.style_incorrect} id="incorrect">Email incorrect</p>
				<p className="error" style={this.state.style_incorrect2} id="incorrect2">Mot de passe incorrect</p>
				<p className="error" style={this.state.style_incorrect3} id="incorrect3">Trop de tentatives, veuillez réessayer dans 5 minutes</p>
			</form>
		</div>
    )
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value })
  }

  onSubmit(e) {
	e.preventDefault();
	console.log("on submit action");

	const user = {
		email      : this.state.email,
		password   : this.state.password,
		return_code: this.state.return_code
	}
	login(user).then(res => {
		console.log("login");
		this._isMounted = true;
		if (res) {
			localStorage.setItem('user',true);
			this.props.changeConnexion(<Connexion  key={"connexion"} connexionAuth={true}/>);
		}
		else{
			if(user.return_code === 400){
				console.log()
				this.setState({style_incorrect:{display:"block"}});
				this.setState({style_incorrect3:{display:"none"}});
				this.setState({style_incorrect2:{display:"none"}});
			}
			if(user.return_code === 401){
				this.setState({style_incorrect2:{display:"block"}});
				this.setState({style_incorrect:{display:"none"}});
				this.setState({style_incorrect3:{display:"none"}});
			}
			if(user.return_code === 429){
				this.setState({style_incorrect3:{display:"block"}});
				this.setState({style_incorrect:{display:"none"}});
				this.setState({style_incorrect2:{display:"none"}});
			}
		}
	})
  }


}//Accolade fin class
export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/Login.js